import { Helmet } from 'react-helmet-async';

interface PageMetaProps {
  title: string;
  description?: string;
  ogImage?: string;
}

export const PageMeta: React.FC<PageMetaProps> = ({ title, description, ogImage }) => {
  return (
    <Helmet>
      <title>{title}</title>
      {description && (
        <meta
          name="description"
          content={description}
        />
      )}
      {title && (
        <meta
          property="og:title"
          content={title}
        />
      )}
      {description && (
        <meta
          property="og:description"
          content={description}
        />
      )}
      <meta
        property="og:type"
        content="website"
      />
      {ogImage && (
        <meta
          property="og:image"
          content={ogImage}
        />
      )}
    </Helmet>
  );
};
